import React from 'react';
import './styles.css';

export interface DetailItem {
  label: string;
  value: React.ReactNode;
}

export interface DetailSectionProps {
  items: DetailItem[];
  title?: string;
  className?: string;
}

/**
 * A component for displaying detail information in a consistent format.
 * Based on the Test detail page style with vertically listed items separated by lines.
 */
const DetailSection: React.FC<DetailSectionProps> = ({
  items,
  title,
  className = '',
}) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <div className={`detail-section ${className}`}>
      {title && <h3 className="detail-section-title">{title}</h3>}
      <div className="detail-items">
        {items.map((item, index) => (
          <div key={index} className="detail-item">
            <label>{item.label}</label>
            <span>{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DetailSection; 